import axios from 'axios';
import utilsService from '@/services/utilsService.ts';

/**
 * User API Service.
 * Communication interface for the User REST API.
 */
export default {
  getUserByGid,
};

const userBaseUrl = `${import.meta.env.VITE_TIME_REPORT_API_BASE_URL}/users`;

/**
 * Return the user filtered by their Gid.
 *
 * @param {String} userGid - The user Gid.
 * @returns {Promise<Object>}
 */
async function getUserByGid(userGid: string) {
  return axios.get(`${userBaseUrl}/${userGid}`).then((result) => {
    return utilsService.fromSnakeCaseToCamelCase(result.data);
  });
}
